/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymSuggestionListAliases {
  APPOINTMENT_SUGGESTION_CARD = 'appointment-suggestion-card',
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_SORT = 'autocomplete-sort',
  BUTTON_CONFIRM = 'button-confirm',
  CARD_SUGGESTION_ITEM = 'card-suggestion-item',
  CHECKBOX_ONLY_TELECONSULTATION = 'checkbox-only-teleconsultation',
  CONTEXTUAL_BAR_SUGGESTION_LIST = 'contextual-bar-suggestion-list',
  DECK_SUGGESTION_GROUPS = 'deck-suggestion-groups',
  DECK_SUGGESTION_ITEMS = 'deck-suggestion-items',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_SORT = 'field-sort',
  FIELD_TELECONSULTATION = 'field-teleconsultation',
  FIELD_WEEK_DAYS = 'field-week-days',
  FILTER_SUGGESTION_TIMES = 'filter-suggestion-times',
  FORM_WEEK_DAYS = 'form-week-days',
  GLOBAL_ACTIONS_SUGGESTION_LIST = 'global-actions-suggestion-list',
  LAYOUT_SUGGESTION_LIST = 'layout-suggestion-list',
  LAYOUT_SUGGESTIONS = 'layout-suggestions',
  LOADER_FILTER = 'loader-filter',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_SORT = 'mapper-sort',
  MAPPER_SUGGESTION_GROUPS = 'mapper-suggestion-groups',
  PANEL_DATE = 'panel-date',
  PANEL_FILTERS = 'panel-filters',
  PANEL_LOAD_CONTENT = 'panel-load-content',
  PANEL_SUGGESTION_GROUPS = 'panel-suggestion-groups',
  PANEL_SUGGESTION_LIST = 'panel-suggestion-list',
  PANEL_SUGGESTIONS = 'panel-suggestions',
  PANEL_WEEK_DAYS = 'panel-week-days',
  SEGMENTED_CONTROL_WEEK_DAYS = 'segmented-control-week-days',
  TEXT_DATE = 'text-date',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_SORT = 'text-sort',
}
export { PseudonymSuggestionListAliases };
